<template>
  <div class="tips" @click.stop>
    <div class="title">{{ title }}</div>
    <div class="text" v-html="message"></div>
    <div class="btn-list">
      <div class="btn-item" v-if="showCancel" @click="bindCancel">{{
        cancelText
      }}</div>
      <div
        class="btn-item btn-item-active"
        v-if="showConfirm"
        @click="bindClick"
        >{{ confirmText }}</div
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: '好的'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '关闭'
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick() {
      this.$emit('confirm')
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.tips {
  text-align: center;
  width: vw(258);
  padding: vw(16) vw(20) vw(20);
  background: #fff;
  border-radius: vw(12);

  .title {
    font-weight: bold;
    font-size: vw(20);
    color: #000000;
    line-height: vw(26);
    margin-bottom: vw(16);
  }

  .text {
    font-size: vw(14);
    color: rgba(0, 0, 0, 0.8);
    line-height: vw(22);
    margin-bottom: vw(24);
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-item {
      width: vw(118);
      height: vw(44);
      text-align: center;
      box-sizing: border-box;
      border: vw(1) solid #f20062;
      background-color: #fff;
      border-radius: vw(22);
      font-weight: bold;
      font-size: vw(18);
      color: #f20062;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: vw(21);
    }
    .btn-item:last-child {
      margin-right: 0;
    }
    .btn-item-active {
      background: #f20062;
      color: #ffffff;
    }
  }
}
</style>
